import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

import { AuthService } from "../../services/auth.service";
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../../app.component.scss', './reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordUserData = <any>{};
  userId: string;
  emailCode: string;

  constructor(private _auth: AuthService, private _router: Router, private _activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
    const routeParams = this._activeRoute.snapshot.params;

    // Reset Password Data
    this.userId = routeParams.user_id;
    this.emailCode = routeParams.email_code;
  }

  resetPassword() {
    this.resetPasswordUserData.user_id = this.userId;
    this.resetPasswordUserData.email_code = this.emailCode;
    this._auth.resetPassword(this.resetPasswordUserData)
      .subscribe(
        res => {
          this._router.navigate(['/auth/employee/login']);
        },
        error => {
          if (error.status == 0) {
          } else if(error.status == 400) {
            var errorData = error.error;
            for (var key in errorData) {
              if (errorData.hasOwnProperty(key)) {
                var val = errorData[key];
              }
            }
          } else {
            this._router.navigate(['/auth/employee/login']);
          }
        }
      )
  }

}
